<div class="landing-wrapper">

    <!-- HERO SECTION -->
    <header class="hero-header">
        <div class="hero-inner">
            <div class="hero-text-col">
                <span class="hero-pill-badge">
                    <mat-icon class="badge-icon">auto_awesome</mat-icon>
                    Soluciones a tu alcance en minutos
                </span>
                <h1 class="hero-headline">
                    Conéctate con expertos verificados para tu hogar, bienestar y proyectos.
                </h1>
                <p class="hero-subheadline">
                    Encuentra especialistas capacitados (Workbies) cerca de ti. Pagos 100% protegidos con ePayco y
                    garantía de calidad en cada servicio.
                </p>

                <!-- BUSCADOR PRINCIPAL -->
                <div class="search-box">
                    <div class="search-input-wrap">
                        <mat-icon class="search-icon">search</mat-icon>
                        <input #searchInput type="text" (focus)="onFocus()"
                            placeholder="¿Qué servicio necesitas hoy? (Ej. Limpieza, Plomería, Mascotas...)">
                    </div>
                    <button mat-flat-button class="search-btn">
                        <span>Buscar</span>
                        <mat-icon>arrow_forward</mat-icon>
                    </button>
                </div>

                <!-- TAGS DE BÚSQUEDA RÁPIDA -->
                <div class="quick-tags">
                    <span class="tags-label">Popular:</span>
                    <div class="tags-list">
                        <span class="tag-item" *ngFor="let tag of quickSearches">{{ tag }}</span>
                    </div>
                </div>

                <!-- TRUST BADGES -->
                <div class="hero-trust-badges">
                    <div class="trust-item">
                        <mat-icon>verified</mat-icon>
                        <span>Expertos Verificados</span>
                    </div>
                    <div class="trust-item">
                        <mat-icon>lock</mat-icon>
                        <span>Pagos Seguros ePayco</span>
                    </div>
                    <div class="trust-item">
                        <mat-icon>star</mat-icon>
                        <span>Servicio Calificado</span>
                    </div>
                </div>
            </div>

            <div class="hero-graphic-col">
                <div class="graphic-card">
                    <img src="assets/images/Workbi_bee.svg" alt="Workbi Mascot" class="mascot-img"
                        onerror="this.style.display='none'">
                    <div class="floating-badge badge-top">
                        <mat-icon>shield_moon</mat-icon>
                        <div>
                            <strong>100% Seguro</strong>
                            <small>Identidad validada</small>
                        </div>
                    </div>
                    <div class="floating-badge badge-bottom">
                        <mat-icon>payments</mat-icon>
                        <div>
                            <strong>Pasarela ePayco</strong>
                            <small>Transacciones cifradas</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>

    <!-- MAIN CONTENT BODY -->
    <main class="main-body">

        <!-- CATEGORÍAS DE SERVICIO -->
        <section class="services-section">
            <div class="section-title-wrap">
                <span class="section-badge">Explora</span>
                <h2 class="section-title">Nuestras Categorías de Servicios</h2>
                <p class="section-subtitle">Selecciona una categoría para descubrir los servicios disponibles en tu
                    ciudad</p>
            </div>

            <swiper-container *ngIf="categories.length > 0" slides-per-view="2" space-between="16"
                breakpoints='{"480": {"slidesPerView": 3}, "768": {"slidesPerView": 4}, "1024": {"slidesPerView": 6}}'
                center-insufficient-slides="true" class="category-swiper">
                <swiper-slide *ngFor="let cat of categories">
                    <div class="category-card" [class.active]="selectedCategory?.categoryId === cat.categoryId"
                        (click)="toggleCategory(cat)">
                        <div class="card-bg" [style.backgroundColor]="cat.backgroundColor"></div>
                        <div class="card-content">
                            <img class="card-icon" [src]="cat.imageUrl" [alt]="cat.categoryName"
                                onerror="this.style.display='none'" />
                            <span class="card-name">{{ cat.categoryName }}</span>
                            <mat-icon class="card-chevron">
                                {{ selectedCategory?.categoryId === cat.categoryId ? 'keyboard_arrow_up' :
                                'keyboard_arrow_down' }}
                            </mat-icon>
                        </div>
                    </div>
                </swiper-slide>
            </swiper-container>

            <!-- SUBCATEGORÍAS PANEL -->
            <div class="subcategories-panel" *ngIf="selectedCategory" [@expandCollapse]>
                <div class="panel-header" [style.borderColor]="selectedCategory.backgroundColor">
                    <div class="panel-title-group">
                        <span class="panel-title">{{ selectedCategory.categoryName }}</span>
                        <span class="panel-count"
                            *ngIf="selectedCategory.subcategories && selectedCategory.subcategories.length > 0">
                            {{ selectedCategory.subcategories.length }} servicios disponibles
                        </span>
                        <span class="panel-count empty-badge"
                            *ngIf="!selectedCategory.subcategories || selectedCategory.subcategories.length === 0">
                            Próximamente
                        </span>
                    </div>
                    <span class="panel-hint"
                        *ngIf="selectedCategory.subcategories && selectedCategory.subcategories.length > 0">
                        Haz clic en un servicio para solicitar información
                    </span>
                </div>

                <!-- SI TIENE SUBCATEGORÍAS -->
                <div class="subcategories-grid"
                    *ngIf="selectedCategory.subcategories && selectedCategory.subcategories.length > 0">
                    <div class="subcategory-card" *ngFor="let sub of selectedCategory.subcategories">
                        <div class="sub-icon-wrap">
                            <img class="sub-icon" [src]="sub.imageIconUrl || sub.imageUrl" [alt]="sub.subcategoryName"
                                onerror="this.style.display='none'" />
                        </div>
                        <span class="sub-name">{{ sub.subcategoryName }}</span>
                    </div>
                </div>

                <!-- SI NO TIENE SUBCATEGORÍAS (ESTADO VACÍO / PRÓXIMAMENTE) -->
                <div class="empty-subcategories"
                    *ngIf="!selectedCategory.subcategories || selectedCategory.subcategories.length === 0">
                    <div class="empty-icon-wrap">
                        <mat-icon>schedule</mat-icon>
                    </div>
                    <h3>Próximamente</h3>
                    <p>Estamos incorporando nuevos especialistas y servicios en la categoría de <b>{{
                            selectedCategory.categoryName }}</b>. ¡Muy pronto estarán disponibles!</p>
                </div>
            </div>
        </section>

        <!-- ¿CÓMO FUNCIONA WORKBI? -->
        <section class="how-it-works-section">
            <div class="section-title-wrap">
                <span class="section-badge">Paso a paso</span>
                <h2 class="section-title">¿Cómo Funciona Workbi?</h2>
                <p class="section-subtitle">Solicitar un servicio o ayuda nunca fue tan sencillo e intuitivo</p>
            </div>

            <div class="steps-grid">
                <div class="step-card" *ngFor="let s of howItWorksSteps">
                    <div class="step-header">
                        <span class="step-number">{{ s.step }}</span>
                        <div class="step-icon-wrap">
                            <mat-icon>{{ s.icon }}</mat-icon>
                        </div>
                    </div>
                    <h3>{{ s.title }}</h3>
                    <p>{{ s.description }}</p>
                </div>
            </div>
        </section>

        <!-- BENEFICIOS / POR QUÉ ELEGIRNOS -->
        <section class="benefits-section">
            <div class="section-title-wrap">
                <span class="section-badge">Confianza</span>
                <h2 class="section-title">¿Por qué Elegir Workbi?</h2>
                <p class="section-subtitle">Diseñado para tu tranquilidad, seguridad y comodidad</p>
            </div>

            <div class="benefits-grid">
                <div class="benefit-card" *ngFor="let b of trustFeatures">
                    <div class="benefit-icon-box">
                        <mat-icon>{{ b.icon }}</mat-icon>
                    </div>
                    <div class="benefit-text">
                        <h3>{{ b.title }}</h3>
                        <p>{{ b.description }}</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- BANNER ÚNETE COMO WORKBIE -->
        <section class="workbie-cta-section">
            <div class="cta-banner">
                <div class="cta-content">
                    <span class="cta-badge">Oportunidad Laboral y Profesional</span>
                    <h2>¿Ofreces Servicios Profesional o Técnico? ¡Únete a Workbi!</h2>
                    <p>
                        Conviértete en un <b>Workbie</b>, gestiona tus propios horarios, conéctate con cientos de
                        clientes cerca de ti y aumenta tus ingresos ofreciendo lo que mejor sabes hacer.
                    </p>
                    <div class="cta-actions">
                        <a href="/quienes-somos" class="cta-btn primary">
                            <span>Conoce Más de Nosotros</span>
                            <mat-icon>arrow_forward</mat-icon>
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <!-- BANNER DESCARGA LA APP -->
        <section class="app-download-section">
            <div class="app-card">
                <div class="app-info">
                    <h2>Lleva Workbi en tu Bolsillo</h2>
                    <p>
                        Descarga nuestra aplicación móvil disponible para Android e iOS. Solicita servicios en tiempo
                        real, gestiona tus pagos y chatea con tus Workbies desde cualquier lugar.
                    </p>
                    <div class="app-badges">
                        <a href="https://play.google.com/store/apps/details?id=co.workbi&pcampaignid=web_share"
                            target="_blank" rel="noopener noreferrer">
                            <img src="assets/images/google-play.svg" alt="Google Play Store" class="app-badge-img">
                        </a>
                        <a href="https://apps.apple.com/co/app/workbi/id6756087985?l=en-GB" target="_blank"
                            rel="noopener noreferrer">
                            <img src="assets/images/download-ios.svg" alt="App Store" class="app-badge-img">
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <!-- PREGUNTAS FRECUENTES (FAQ) -->
        <section class="faq-section">
            <div class="section-title-wrap">
                <span class="section-badge">Dudas Recurrentes</span>
                <h2 class="section-title">Preguntas Frecuentes</h2>
                <p class="section-subtitle">Resolvemos tus principales inquietudes sobre la plataforma</p>
            </div>

            <div class="faq-accordion">
                <div class="faq-item" *ngFor="let faq of faqs; let i = index" [class.open]="faq.open"
                    (click)="toggleFaq(i)">
                    <div class="faq-question">
                        <h3>{{ faq.question }}</h3>
                        <mat-icon class="faq-chevron">{{ faq.open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                            }}</mat-icon>
                    </div>
                    <div class="faq-answer" *ngIf="faq.open" [@expandCollapse]>
                        <p>{{ faq.answer }}</p>
                    </div>
                </div>
            </div>
        </section>

    </main>

</div>